import {ChangeEvent} from 'react';
import {PlayerRef} from './AccuratePlayer/AccuratePlayerTypes';

export type PlayerType = {
    setPlaybackRate: (rate: number) => number;
    playbackRates: number[];
    pause: () => Promise<void>;
    getStatus: () => {
        paused: boolean;
    };
};

type Dispatch<A> = (value: A) => void;
type SetStateAction<N> = N | ((prevState: N) => N);

export interface SpeedChangeProps {
    player: PlayerType;
    setPlaybackSpeed: Dispatch<SetStateAction<number>>;
    playbackOptions: number[];
}

export type PlaybackSpeedChange = (event: ChangeEvent<{value: unknown}>) => void;

export interface HandleEffectProps {
    playerRef: PlayerRef;
    setPlaybackOptions: Dispatch<SetStateAction<number[]>>;
}

export const PLAYBACK_SPEED_OPTIONS = [-16, -8, -4, -2, -1, 0.5, 1, 2, 4, 8, 16, 32, 64];

export const DEFAULT_PLAYBACK_SPEED = 1;
